// @mui
import useLocales from "@hooks/useLocales";
import { Stack, Typography } from "@mui/material";
// assets

//hooks
import { Button, useTheme } from "@mui/material";

// ----------------------------------------------------------------------

interface BlockContentProps {
  // fileName: string;
  // fileMessage: string;
  acceptedFiles: string;
  contentFooter?: string;
}

export function BlockContentV2({
  // fileName,
  // fileMessage,
  acceptedFiles,
  contentFooter,
}: BlockContentProps) {
  const { translate } = useLocales();
  const theme = useTheme();
  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: "column", md: "column" }}
      sx={{ width: 1, textAlign: { xs: "center", md: "left" } }}
    >
      <Typography variant="h6">{translate("upload_your_document")}</Typography>
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.label, textAlign: "center" }}
      >
        {translate("drag_and_drop_your_files_here")}
        &nbsp;
      </Typography>
      <Button
        variant="contained"
        sx={{
          textAlign: "center",
        }}
        size="small"
      >
        {translate(`browse_files`)}
      </Button>
      <Typography
        variant="body2"
        sx={{ color: theme.palette.text.label, textAlign: "center" }}
      >
        {contentFooter
          ? contentFooter
          : translate("files_accepted_only", { acceptedFiles })}
      </Typography>
    </Stack>
  );
}
